<!-- eslint-disable vue/no-template-shadow -->
<template>
    <section class="menu-card">
        <ui-menu-card  icon="fal fa-cog" background-control="#f8f9fe">
            <template #options>
                <div class="itens-filter">
                    <div v-for="(filter, index) in filtersComputed" :key="index" class="filter">
                        <div v-if="filter.name != 'idleness'" class="title">
                            {{filter.title}}
                        </div>
                        <div v-for="(item, i) in filter.items" :key="i" class="items">
                            <div v-if="filter.name == 'sort-by'" class="radio">
                                <ui-checkbox :id="i" :checked.sync="item.checked" @input="sortByHandler($event, i)" />
                                <div class="info" :title="item.name">
                                    {{ item.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #control>
                <div class="buttons-options">
                    <ui-button class="cleam" design="smd link" @click="clear">Limpar Filtros</ui-button>
                    <ui-button design="smd primary" @click="filter">Aplicar</ui-button>
                </div>
            </template>
        </ui-menu-card>
    </section>
</template>

<script>
	import { uiMenuCard } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { uiCheckbox } from '@/components/ui/form'
	export default {
		name:'components-filter',
		components: {
			uiMenuCard,
			uiCheckbox,
			uiButton,
		},

		props: {
			/**
			 * Prop indicando se o kanban no qual o filtro está inserido representa
			 * uma etapa ou um status
			 */
			forStatus: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Prop representando o(s) status da etapa
			 */
			status: {
				type: [Array, Object],
				required: true
			},
			/**
			 * Prop representando as regras de ociosidade da etapa
			 */
			idles: {
				type: Array,
				required: true
			}
		},

		data () {
			return {
				filters: [
					{
						title: 'Ordenar por:',
						name: 'sort-by',
						items: [
							{
								label: 'Atualização mais recente',
								checked: false,
								value: 'updated_at',
								dir: 'desc'
							},
							{
								label: 'Atualização mais antiga',
								checked: false,
								value: 'updated_at',
								dir: 'asc'
							},
							{
								label: 'Ordem Alfabética - A - Z',
								checked: false,
								value: 'customer_name',
								dir: 'asc'
							},
							{
								label: 'Ordem Alfabética - Z - A',
								checked: false,
								value: 'customer_name',
								dir: 'desc'
							}
						],
						selected: { value: '', dir: '' }
					}
				]
			}
		},

		computed: {
			filtersComputed() {
				return this.filters.filter(f => !f.hidden)
			}
		},

		created() {
			const sIndex = this.filters.findIndex(filter => filter.name === 'status')
			const iIndex = this.filters.findIndex(filter => filter.name === 'idleness')
			const idles = this.idles.filter(idle => !idle.funnel_stage_status_id)
				.map(idle => {
					idle.status = 'Ociosidades da Etapa'
					return idle
				})
				if(this.filters?.[iIndex] && idles) this.$set(this.filters[iIndex], 'items', [...idles])
			if (!this.forStatus) {
				const status = Object.values(this.status).map(s => {
					return { id: s.id, name: s.name, checked: false }
				})
				if(this.filters[sIndex] && status) this.$set(this.filters[sIndex], 'items', [...status])
			} else {
				this.statusHandler(true, this.status.id)
				this.$set(this.filters[sIndex], 'hidden', true)
			}
		},

		methods: {
			/**
			 * Função handler que trata o evento de quando um status é selecionado,
			 * de modo a setar as ociosidades no select2
			 */
			statusHandler(checked, value) {
				const sIndex = this.filters.findIndex(filter => filter.name === 'status')
				const iIndex = this.filters.findIndex(filter => filter.name === 'idleness')

				if (checked) {
					// Seta o ID do status no array de status selecionados
					this.filters[sIndex].selected.push(value)

					// Filtra as ociosidades a serem incluídas no select2
					const status = this.forStatus
						? { ...this.status }
						: this.status.find((status) => status.id === value)
					const idles = status.idles.map(idle => {
						idle.status = status.name
						return idle
					})

					this.$set(this.filters[iIndex], 'items', [...this.filters[iIndex].items, ...idles])

				} else {
					// Remove o ID do array de status selecionados
					this.filters[sIndex].selected.splice(this.filters[sIndex].selected.indexOf(value), 1)

					// Remove as ociosidades do status desselecionado
					const idles = this.filters[iIndex].items.filter(item => item.funnel_stage_status_id !== value)
					if(this.filters?.[iIndex] && idles) this.$set(this.filters[iIndex], 'items', [...idles])
				}
			},
			/**
			 * Função handler que trata o evento de quando um status é selecionado,
			 * de modo a setar as ociosidades no select2
			 */
			sortByHandler(checked, index) {
				const sIndex = this.filters.findIndex(filter => filter.name === 'sort-by')
				const sorts = this.filters[sIndex].items.map((item, i) => {
					item.checked = i === index ? checked : false
					return item
				})

				if (checked) {
					const sort = this.filters[sIndex].items[index]
					this.$set(this.filters[sIndex], 'selected', { value: sort.value, dir: sort.dir })

				} else {
					this.$set(this.filters[sIndex], 'selected', { value: '', dir: '' })
				}
				this.$set(this.filters[sIndex], 'items', sorts)
			},
			/**
			 * Emite o evento para realizar a filtragem dos negócios, passando os status
			 * e ociosidades selecionadas
			 */
			filter() {
	
				const sbIndex = this.filters.findIndex(filter => filter.name === 'sort-by')

				const params = {
					sort_by: { ...this.filters[sbIndex].selected }
				}
				this.$emit('filter', params)
			},
			/** Emite o evento para limpar a filtragem */
			clear() {
				const sbIndex = this.filters.findIndex(filter => filter.name === 'sort-by')
				const sorts = this.filters[sbIndex].items.map(item => {
					item.checked = false

					return item
				})

				this.$set(this.filters[sbIndex], 'items', sorts)
				this.$set(this.filters[sbIndex], 'selected', { value: 'updated_at', dir: 'desc' })

				this.$emit('clear')
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>